export const errors = {
  expiredGoogleSession: 'Google: Google session expired',
  expiredLoginToken: 'Resuming: Login token expired',
  missingCreateAccountResponse: 'Account: Failed to create account',
  missingGoogleUser: 'Google: Failed to create google user',
  missingUpdatePlanPaymentResponse: 'Payment: Failed to update plan payment',
  missingTelesalesUserId: 'User ID not passed to telesales-link service',
  missingUserIdToGenerateContract: 'DocuSign: Missing user id',
  missingUtilityAccountIdToGenerateContract:
    'DocuSign: Missing utility account id in contract generation',
  missingFetchStripeToken: 'Payment: Missing stripe token',
};
